import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {
    Step,
    Stepper,
    StepButton,
    StepContent,
} from 'material-ui/Stepper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Snackbar from 'material-ui/Snackbar';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ShareIcon from 'material-ui/svg-icons/social/share';
import GeneralTab from '../components/GeneralTab';
import StrategyTab from '../components/StrategyTab';
import FastTrackTab from '../components/FastTrackTab';
import BenefitTab from '../components/BenefitTab';
import RiskTab from '../components/RiskTab';
import ScopeTab from '../components/ScopeTab';
import RequiredTab from '../components/RequiredTab';
import AttachmentTab from '../components/AttachmentTab';
import ProcessProposal from '../components/ProcessProposal';
import WarningIcon from 'material-ui/svg-icons/alert/warning';
import { orange500 } from 'material-ui/styles/colors';

import { calculateAverages } from '../utils/calc';

import {
    clearProposal,
    getProposal,
    saveProposalData,
    sendForProcessing,
    saveProcessedData,
    saveFiles,
    deleteFile,
} from '../actions/proposalAction';

import {
    getCostCenters,
} from '../actions/costCenterAction';

import {
    getFieldOptions,
} from '../actions/optionsActions';

import {
    PROPOSAL_CREATED,
    PROPOSAL_SAVED,
    TIL_BEHANDLING_STATUS,
} from '../constants/actions';

class ProposalPage extends React.Component {
    state = {
        proposal: {
            Author: '',
            GeneralData: {
                Title: '',
                DescriptionOfNeed: '',
                Benefit: '',
                Scope: '',
                Risk: '',
                Strategic: '',
                MainUser: '',
                MainAdmin: '',
            },
            Attachments: [],
            ProcessedDate: null,
            ProposedStart: null,
        },
        showSnackbar: false,
        snackMessage: '',
        error: '',
        success: null,
        stepIndex: 0,
        forvaltningOpts: [],
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(clearProposal());

        if (!this.props.forvaltningOptions) {
            dispatch(getFieldOptions('Forvaltningsomrade'));
        }

        dispatch(getCostCenters());

        const proposalId = (this.props.params && this.props.params.Id) ? this.props.params.Id : null;
        if (proposalId !== null) {
            this.props.dispatch(getProposal(proposalId));
        }
    }

    componentWillReceiveProps(nextProps) {
        const state = {};

        if (nextProps.success !== this.state.success) {
            switch (nextProps.success) {
                case PROPOSAL_CREATED:
                state.showSnackbar = true;
                state.snackMessage = 'Forslag opprettet';
                if (!this.props.params.Id) {
                    return this.props.router.push(`/edit/${nextProps.proposal.Id}`);
                }
                break;

                case PROPOSAL_SAVED:
                state.showSnackbar = true;
                state.snackMessage = 'Forslag lagret';
                break;

                case TIL_BEHANDLING_STATUS:
                return this.props.router.push('/');
            }

            state.success = nextProps.success;
        }

        if (nextProps.error !== this.state.error && nextProps.error.length) {
            state.snackMessage = nextProps.error;
            state.showSnackbar = true;
        }


        if (this.props.params.Id !== nextProps.params.Id) {
            this.props.dispatch(getProposal(nextProps.params.Id));
        }

        if (nextProps.proposal.GeneralData && Object.keys(nextProps.proposal.GeneralData).length) {
            const proposal = {...nextProps.proposal, GeneralData: {...nextProps.proposal.GeneralData}};
            calculateAverages(proposal);
            state.proposal = proposal;
        }

        if (nextProps.forvaltningOptions) {
            state.forvaltningOpts = [...nextProps.forvaltningOptions];
        }

        this.setState(state);
    }

    fieldChange = (field, value, recalc) => {
        const keys = field.split('.');
        const last = keys.pop();
        const proposal = {...this.state.proposal};
        keys.reduce((o, k) => {
            return o[k] = o[k] || {};
        }, proposal)[last] = value;

        if (recalc) {
            calculateAverages(proposal);
        }
        this.setState({proposal});
    }


    handleSave = () => {
        const { proposal } = this.state;
        this.props.dispatch(saveProposalData(proposal));
    }

    isGeneralOk = () => {
        const GeneralData = this.state.proposal && this.state.proposal.GeneralData;
        return GeneralData &&
            GeneralData.Title && GeneralData.Title.length &&
            GeneralData.DescriptionOfNeed && GeneralData.DescriptionOfNeed.length &&
            GeneralData.Benefit && GeneralData.Benefit.length &&
            GeneralData.Scope && GeneralData.Scope.length &&
            GeneralData.Risk && GeneralData.Risk.length &&
            GeneralData.Strategic && GeneralData.Strategic.length &&
            GeneralData.MainUser && GeneralData.MainUser.length;
    }

    handleSubmit = () => {
        const { proposal } = this.state;

        if (this.isGeneralOk()) {
            this.props.dispatch(sendForProcessing(this.state.proposal));
        }
        else {
            this.setState({showSnackbar: true, snackMessage: 'Alle påkrevde felt er ikke fylt ut.'});
        }
    }

    handleSaveProcessed = () => {
        this.props.dispatch(saveProcessedData(this.state.proposal));
    }

    handleCloseSnack = () => {
        this.setState({showSnackbar: false});
    }

    handleShareUrl = () => {
        const { location } = window;
        if (this.state.shareUrl) {
            this.setState({
                shareUrl: null,
            });
        }
        else {
            this.setState({
                shareUrl: `${location.origin}${location.pathname}?r=${location.hash.replace('#', '')}`,
            });
        }
    }

    handleUpload = (files) => {
        if (this.props.params && this.props.params.Id && files && files.length) {
            const attachments = this.props.proposal.Attachments.reduce((mem, file) => {
                mem[file] = true;
                return mem;
            }, {});

            files = files.filter((file) => !attachments[file.name]);

            this.props.dispatch(saveFiles(this.props.params.Id, files));
        }
    }

    handleDeleteFile = (file) => {
        if (this.props.params && this.props.params.Id && file) {
            this.props.dispatch(deleteFile(this.props.params.Id, file));
        }
    }

    handleClickFile = (file) => {
        const url = `${window._spPageContextInfo.webServerRelativeUrl}/Lists/Endringsforslag/Attachments/${this.props.params.Id}/${file}`;
        window.open(url, 'SPDownload');
    }

    handleNextStep = () => {
        const proposalIsOpen = this.state.proposal.Status1 === "Under utfylling" || this.state.proposal.Status1 === "" || this.state.proposal.Status1 === undefined;
        const isOwner = this.state.proposal.Author === '' || this.state.proposal.Author === this.props.viewer.WorkEmail;
        if (this.props.viewer.canAdd && proposalIsOpen && isOwner) {
            this.props.dispatch(saveProposalData(this.state.proposal));
        }
        this.setState({stepIndex: this.state.stepIndex +1});
    }



    handlePrevStep = () => {
        this.setState({stepIndex: Math.max(0, this.state.stepIndex -1)});
    }

    render() {
        const { viewer } = this.props;
        const { proposal, showSnackbar, snackMessage, shareUrl, stepIndex, forvaltningOpts } = this.state;
        const isOwner = this.state.proposal.Author === '' || this.state.proposal.Author === this.props.viewer.WorkEmail;
        let canEdit = false;
        const proposalIsOpen = this.props.proposal.Status1 === "Under utfylling" || this.props.proposal.Status1 === "" || this.props.proposal.Status1 === undefined;
        if(!this.props.params.Id) {
            canEdit = true;
        } else if(!proposalIsOpen) {
            canEdit = viewer.canProcess;
        } else {
            canEdit = isOwner;
        }
        const title = proposal.GeneralData && proposal.GeneralData.Title && (
            <h2>{proposal.GeneralData.Title}</h2>
        );

        //const buttons = viewer.canAdd && proposalIsOpen && (
        const buttons = canEdit && (
            <div style={{marginTop: '1rem', paddingTop: '1rem'}}>
                <RaisedButton
                    label="Lagre"
                    primary={true}
                    onClick={this.handleSave}
                    style={{marginRight: '.5rem'}}
                    disabled={proposal.GeneralData.Title.length === 0}
                />

                {this.props.params && this.props.params.Id && (
                    <RaisedButton
                        label="Send til behandling"
                        onClick={this.handleSubmit}
                        style={{marginRight: '.5rem'}}
                    />
                )}
            </div>
        );

        const processProposal  = viewer.canProcess && !proposalIsOpen && (
            <ProcessProposal
                router={this.props.router}
                data={proposal}
                fieldChange={this.fieldChange}
                saveProcessed={this.handleSaveProcessed}
                forvaltningOptions={forvaltningOpts}
            />
        );

        const stepButtonsEdit = (
            <div style={{marginTop: 24, borderTop: '1px solid #bdbdbd', paddingTop: 12}}>
                <RaisedButton
                    label={stepIndex >= 7 ? 'Fullfør' : 'Neste'}
                    primary={true}
                    onClick={this.handleNextStep}
                />

                { (0 < stepIndex) && (stepIndex < 7) &&  (
                    <FlatButton
                        label="Tilbake"
                        onClick={this.handlePrevStep}
                        style={{marginLeft: 12}}
                    />
                )}
            </div>
        );

        const lastStepView = (
            <div style={{marginTop: 24, borderTop: '1px solid #bdbdbd', paddingTop: 12}}>
                {stepIndex > 0 &&  (
                    <RaisedButton
                        label="Tilbake"
                        onClick={this.handlePrevStep}
                        primary={true}
                    />
                )}
            </div>
        );

        return (
            <section style={{
                maxWidth: 768,
                margin: '0 auto',
            }}>
                <div style={{float: 'right'}}>
                    {shareUrl && <TextField id="shareUrl" value={shareUrl} />}
                    <FloatingActionButton secondary={true} mini={true} onClick={this.handleShareUrl} zDepth={1}>
                        <ShareIcon/>
                    </FloatingActionButton>
                </div>

                <h1>Endringsforslag</h1>
                <p style={{
                    fontSize: '.9rem',
                    padding: '2em',
                    backgroundColor: '#f7f7f7',
                    clear: 'both',
                    maxWidth: 768,
                    margin: '0 auto',
                }}>
                    Skjemaet har til hensikt å gi underlag til beslutningstakere om å iverksette endring og «Etablere prosjekt/forvaltningsoppdrag», - i dette som grunnlag for at prosjektet skal finansieres, prioriteres og få tilgang på ressurser.
                </p>

                <Snackbar
                    open={showSnackbar}
                    message={snackMessage}
                    autoHideDuration={4000}
                    onRequestClose={this.handleCloseSnack}
                />

                {title}

                <Stepper
                    activeStep={stepIndex}
                    linear={false}
                    orientation="vertical"
                >
                    <Step completed={stepIndex > 0}>
                        <StepButton
                            onClick={() => this.setState({stepIndex: 0})}
                            icon={(stepIndex > 0 && !this.isGeneralOk()) ? <WarningIcon color={orange500}/> : "1"}
                        >Generell informasjon</StepButton>
                        <StepContent>
                            <GeneralTab
                                fieldChange={this.fieldChange}
                                data={proposal.GeneralData}
                                costCenters={this.props.costCenters}
                                disabled={!canEdit}
                            />
                            {stepButtonsEdit}
                        </StepContent>
                    </Step>

                    <Step completed={stepIndex > 1}>
                        <StepButton onClick={() => this.setState({stepIndex: 1})}>Strategi - er aktiviteten relatert til strategiske satsningsområder?</StepButton>
                        <StepContent>
                            <StrategyTab
                                fieldChange={this.fieldChange}
                                data={proposal}
                                costCenters={this.props.costCenters}
                                disabled={!canEdit}
                            />
                            {stepButtonsEdit}
                        </StepContent>
                    </Step>

                    <Step completed={stepIndex > 2}>
                        <StepButton onClick={() => this.setState({stepIndex: 2})}>Nytte - hva er antatt nytteverdi av å gjennomføre forslaget?</StepButton>
                        <StepContent>
                            <BenefitTab
                                fieldChange={this.fieldChange}
                                data={proposal}
                                costCenters={this.props.costCenters}
                                disabled={!canEdit}
                            />
                            {stepButtonsEdit}
                        </StepContent>
                    </Step>

                    <Step completed={stepIndex > 3}>
                        <StepButton onClick={() => this.setState({stepIndex: 3})}>Omfang - hva er forventet omfang av å gjennomføre forslaget?</StepButton>
                        <StepContent>
                            <ScopeTab
                                fieldChange={this.fieldChange}
                                data={proposal}
                                costCenters={this.props.costCenters}
                                disabled={!canEdit}
                            />
                            {stepButtonsEdit}
                        </StepContent>
                    </Step>

                    <Step completed={stepIndex > 4}>
                        <StepButton onClick={() => this.setState({stepIndex: 4})}>Risiko - hva er antatt risiko tilknyttet forslaget?</StepButton>
                        <StepContent>
                            <RiskTab
                                fieldChange={this.fieldChange}
                                data={proposal}
                                costCenters={this.props.costCenters}
                                disabled={!canEdit}
                            />
                            {stepButtonsEdit}
                        </StepContent>
                    </Step>

                    <Step completed={stepIndex > 5}>
                        <StepButton onClick={() => this.setState({stepIndex: 5})}>Fast-Track</StepButton>
                        <StepContent>
                            <FastTrackTab
                                fieldChange={this.fieldChange}
                                data={proposal}
                                costCenters={this.props.costCenters}
                                disabled={!canEdit}
                            />
                            {stepButtonsEdit}
                        </StepContent>
                    </Step>

                    <Step completed={stepIndex > 6}>
                        <StepButton onClick={() => this.setState({stepIndex: 6})}>Pålagt</StepButton>
                        <StepContent>
                            <RequiredTab
                                fieldChange={this.fieldChange}
                                data={proposal}
                                costCenters={this.props.costCenters}
                                disabled={!canEdit}
                            />
                            {stepButtonsEdit}
                        </StepContent>
                    </Step>

                    <Step completed={stepIndex > 7}>
                        <StepButton onClick={() => this.setState({stepIndex: 7})}>Vedlegg</StepButton>
                        <StepContent>
                            <AttachmentTab
                                attachments={proposal.Attachments}
                                onUploadFiles={this.handleUpload}
                                onDeleteFile={this.handleDeleteFile}
                                onClickFile={this.handleClickFile}
                                disabled={!(this.props.params && this.props.params.Id)}
                            />

                            {!proposalIsOpen || !isOwner ? lastStepView : stepButtonsEdit}
                        </StepContent>
                    </Step>
                </Stepper>

                {buttons}

                {processProposal}
            </section>
        );
    }
}

ProposalPage.propTypes = {
    router: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    proposal: PropTypes.object.isRequired,
    viewer: PropTypes.object.isRequired,
    costCenters: PropTypes.array.isRequired,
    forvaltningOptions: PropTypes.array,
    success: PropTypes.string,
    error: PropTypes.string,
};

function mapStateToProps(state) {
    return {
        proposal: state.proposalData.proposal,
        viewer: state.viewer.viewer,
        costCenters: state.costCenterData.costCenterList,
        forvaltningOptions: state.options.Forvaltningsomrade,
        success: state.proposalData.success,
        error: state.proposalData.error,
    };
}

export default connect(mapStateToProps)(ProposalPage);



// WEBPACK FOOTER //
// ./src/containers/ProposalPage.js